import { DetailSkeleton } from 'components/skeletons';
import React from 'react';
import { Box, IconButton, Tab, Tabs, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { format } from "date-fns";
import { fr } from 'date-fns/locale';

import { TabPanel } from 'components/TabPanel';
import { CandidatesPartial } from './partials/candidates.partial';
import { Link, useParams } from 'react-router-dom';
import { PositionPartial } from './partials/position.partial';
import { ProfilePartial } from './partials/profile.partial';
import { useGetOffer } from 'core/offers/hooks';
import { useTabsContext } from 'components/tabs/hooks';
import { TabsContextProvider } from 'components/tabs/context';
import { CardHeader } from 'components/cards/header';
import { Edit } from '@mui/icons-material';

type Props = {
    offer: any;
};

const ShowTabs = ({offer}: Props) => {
    const {tabValue, changeTab} = useTabsContext();

    return (
        <Box component='main'>
            <Box component='nav' sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue} indicatorColor='primary' onChange={changeTab} sx={{'& button.Mui-selected': {color: '#000'}}} aria-label="Tab attribues candidat">
                    <Tab label={`Candidats ${offer.applications.length}`} disableRipple sx={{ textTransform: 'none' }} />
                    <Tab label="Poste" disableRipple sx={{ textTransform: 'none' }} />
                    <Tab label="Profil" disableRipple sx={{ textTransform: 'none' }} />
                    {/* <Tab label="Notes" disableRipple sx={{ textTransform: 'none' }} /> */}
                </Tabs>
            </Box>
            <TabPanel value={tabValue} index={0}>
                <CandidatesPartial applications={offer.applications} />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <PositionPartial offer={offer} />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
                <ProfilePartial offer={offer} />
            </TabPanel>
            {/* <TabPanel value={tabValue} index={3}>
                Notes
            </TabPanel> */}
        </Box>
    );
};

const ShowPage = () => {
    // Custom Hooks
    const {offerId} = useParams();
    const {data, isLoading, isError} = useGetOffer(Number(offerId!), {onError: (err) => toast.error("Une Erreur est survenue")});

    if (isLoading) { return (<DetailSkeleton />); }
    if (!isLoading && (isError || data === undefined)) { return (<Typography>Une erreur est survenue</Typography>); }

    return (
        <Box sx={{mt: '1rem'}}>
            <CardHeader
                title={`${data.job_title}`}
                subtitle={`Posté le ${format(Date.parse(data.posting_date), 'dd/MM/yy', {locale: fr})}`}
                chips={[
                    {label: data.source, color: 'info'},
                    {label: data.job_contract, color: 'success'},
                ]}
                rightComponent={(
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', my: 3, gap: '1rem' }}>
                        {data.source === 'backoffice' && <Link to={`/dashboard/offers/${data.id}/edit`}><IconButton color='info'><Edit /></IconButton></Link>}
                    </Box>
                )}
            />
            <TabsContextProvider>
                <ShowTabs offer={data} />
            </TabsContextProvider>
        </Box>
    );
};

export { ShowPage };